import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { productTypesAPI } from "../../api/productTypes/productTypes";

const initialState = {
    productTypes: [],
    status: null,
    error: null,
};

export const uploadProductTypes = createAsyncThunk(
    "productTypeSelect/uploadProductTypes",
    async () => {
        const response = await productTypesAPI.getProductTypes();
        return response;
    }
);


export const productTypeSelectSlice = createSlice({
    name: "productTypeSelect",
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            .addCase(uploadProductTypes.pending, (state, action) => {
                state.status = "pending";
                state.error = null;
            })
            .addCase(uploadProductTypes.fulfilled, (state, action) => {
                state.status = "fulfilled";
                state.error = null;

                if(!action.payload?.productTypes){ 
                    state.status = "rejected";
                    state.error = 'something_went_wrong';
                    return
                }

                state.productTypes = action.payload.productTypes;
            })
            .addCase(uploadProductTypes.rejected, (state, action) => {
                state.status = "rejected";
                state.error = action.payload?.err ?? 'something_went_wrong';
            });
    }
});

export const selectProductTypes = (state) => state.selectProductType.productTypes;

export default productTypeSelectSlice.reducer;